<div class="flex justify-end my-8">
  <button
    mat-flat-button
    color="primary"
    class="my-16 mr-8"
    printSectionId="print-section"
    ngxPrint
    [useExistingCss]="true"
  >
    Print
  </button>
  <button
    mat-flat-button
    color="primary"
    class="my-16 mx-8"
    (click)="emailPressureTestCertificate()"
  >
    Email
  </button>
  <button
    mat-flat-button
    color="primary"
    class="my-16 ml-8 mr-32"
    (click)="openPDF()"
  >
    Download
  </button>
</div>

<div class="flex flex-col fixed-width p-32" id="print-section">
  <header><img src="../../../assets/dlm-images/dlm/dlm-header.png" /></header>
  <table class="print-content">
    <thead>
      <tr>
        <td>&nbsp;</td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <div class="flex justify-center my-16 w-full">
            <h1 class="">PRESSURE TEST AND INSPECTION CERTIFICATE</h1>
          </div>
          <div class="flex flex-col general-details-container my-16 w-full">
            <div class="flex flex-row items-stretch w-full">
              <div class="title cell px-8 pb-3">Customer</div>
              <div class="data cell px-8 pb-3">
                {{ model?.customer }}
              </div>

              <div class="title cell px-8 pb-3">Certificate Number</div>
              <div class="data cell px-8 pb-3">
                {{ model?.certificateNumber }}
              </div>
            </div>
            <div class="flex flex-row items-stretch w-full">
              <div class="title cell px-8 pb-3">Calibrated On</div>
              <div class="data cell px-8 pb-3">
                {{ model?.calibratedOn | date: "dd/MM/yyyy" }}
              </div>
              <div class="title cell px-8 pb-3">Recalibration Due</div>
              <div class="data cell font-red px-8 pb-3">
                {{ model?.calibratedDue | date: "dd/MM/yyyy" }}
              </div>
            </div>
            <div class="flex flex-row items-stretch w-full">
              <div class="title cell px-8 pb-3">Customer Code</div>
              <div class="data cell px-8 pb-3">{{ model?.customerCode }}</div>
              <div class="title cell px-8 pb-3">Customer Order</div>
              <div class="data cell px-8 pb-3">{{ model?.customerOrder }}</div>
            </div>
            <div class="flex flex-row items-stretch w-full">
              <div class="title cell px-8 pb-3">Sales Order</div>
              <div class="data cell px-8 pb-3">
                {{ model?.salesOrder }}
              </div>
              <div class="title cell px-8 pb-3">Customer Reference</div>
              <div class="data cell px-8 pb-3">
                {{ model?.customerReference }}
              </div>
            </div>
          </div>

          <p>
            We certify that the items listed below have been hydrostatically
            pressure tested
          </p>

          <div class="flex flex-row items-stretch w-full">
            <div class="title cell font-12  px-8 pb-3">Item</div>
            <div class="title cell font-12  px-8 pb-3">Serial Number</div>
            <div class="title cell font-12  px-8 pb-3">WLL</div>
            <div class="title cell font-12  px-8 pb-3">Bar</div>
            <div class="title cell font-12  px-8 pb-3">Results of Test</div>
            <div class="title cell font-12  px-8 pb-3">Pressure Gauge</div>
            <div class="title cell font-12  px-8 pb-3">Serial Number</div>
            <div class="title cell font-12  px-8 pb-3">Last calibrated on</div>
            <div class="title cell font-12  overflow px-8 pb-3">Next calibration due</div>
          </div>

          <div
            *ngFor="let item of model?.pressureTestItems; let i = index"
            class="flex flex-row justify-center items-stretch w-full avoid-break"
          >
            <div class="cell flex flex-col w-full">
              <div class="px-8">
                <p class="font-12">{{ item.loadcellId + "/" + (i + 1) }}</p>
              </div>
            </div>
            <div class="cell flex flex-col w-full">
              <div class="px-8">
                <p class="font-12">{{ item?.loadcellSerialNumber }}</p>
              </div>
            </div>
            <div class="cell flex flex-col w-full">
              <div class="px-8">
                <p class="font-12">{{ item?.swl }}</p>
              </div>
            </div>
            <div class="cell flex flex-col w-full">
              <div class="px-8">
                <p class="font-12">{{ item?.bar }}</p>
              </div>
            </div>
            <div class="cell flex flex-col w-full">
              <div class="px-8">
                <p class="font-12">{{ item?.resultOfTest }}</p>
              </div>
            </div>
            <div class="cell flex flex-col w-full">
              <div class="px-8">
                <p class="font-12">{{ item?.pressureGauge }}</p>
              </div>
            </div>
            <div class="cell flex flex-col w-full">
              <div class="px-8">
                <p class="font-12">{{ item?.calibrationSerialNumber }}</p>
              </div>
            </div>
            <div class="cell flex flex-col w-full">
              <div class="px-8">
                <p class="font-12">
                  {{ item?.lastCalibrated ?? "" | date: "dd/MM/yyyy" }}
                </p>
              </div>
            </div>
            <div class="cell flex flex-col w-full">
              <div class="px-8">
                <p class="font-12">
                  {{ item?.calibrationDue ?? "" | date: "dd/MM/yyyy" }}
                </p>
              </div>
            </div>
          </div>

          <div class="flex flex-col w-full avoid-break mt-8">
            <p>Certifying Engineer:</p>
            <div class="flex flex-row mx-16 w-50">
              <img src="{{ model?.signature }}" />
            </div>
            <p>{{ model?.employeeName }}</p>
          </div>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td>&nbsp;</td>
      </tr>
    </tfoot>
  </table>
  <footer><img src="../../../assets/dlm-images/dlm/dlm-footer-grey.png" /></footer>
</div>
